import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A seemingly small workmanship error can lead to significant reduction of sound insulation performance. The example shows two floors with identical load-bearing construction, but with a different finish. The parquet floor has been properly finished, with no contact with the wall. On the other hand, the ceramic tile finish touches the skirting board and the wall. Listen to the sound of the tapping machine placed on these two floors, as heard in the room below.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 4,
      rowSpan: {
        "0:1": 4,
      },
      rowsSize: [3, 1, 3, 1],
      colsSize: [2, 3],
      components: [
        [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/24/principle/parquet-floor-well-executed.svg`,
                    onHoverAction: [
                      {
                        type: "changeOptions",
                        options: {
                          src: `${config.ASSETS_URL}/05/24/principle/parquet-floor-well-executed-zoom.svg`,
                        },
                      },
                    ],
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/24/principle/chart-badge.svg`,
                  },
                },
                styles: {
                  padding: "3%",
                },
              },
            },
          ],
        ],
        [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume",
                    text: "Parquet floor well executed",
                    shape: "round",
                    theme: "secondary",
                    url: `${config.ASSETS_URL}/05/24/principle/parquet-floor-well-executed.wav`,
                  },
                },
                styles: {
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
        [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/24/principle/ceramic-floor-bad-detail.svg`,
                    onHoverAction: [
                      {
                        type: "changeOptions",
                        options: {
                          src: `${config.ASSETS_URL}/05/24/principle/ceramic-floor-bad-detail-zoom.svg`,
                        },
                      },
                    ],
                  },
                },
              },
            },
          ],
        ],
        [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume",
                    text: "Ceramic floor bad detail",
                    shape: "round",
                    theme: "secondary",
                    url: `${config.ASSETS_URL}/05/24/principle/ceramic-floor-bad-detail.wav`,
                  },
                },
                styles: {
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
      ],
    },
  },
};

export default principle;
